// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { productAttributesStyles } from "@guestsupply/Overrides/Components/ProductAttributes";
import { css } from "styled-components";

productAttributesStyles.container = {
    gap: 0,
};
productAttributesStyles.attributeTypeGridItem = {
    width: [6, 6, 6, 4, 4],
    css: css`
        overflow: hidden;
    `,
};
productAttributesStyles.attributeValueGridItem = {
    width: [6, 6, 6, 8, 8],
    css: css`
        overflow: hidden;
    `,
};
productAttributesStyles.attributeTypeText = {
    weight: "bold",
};
productAttributesStyles.smallHeadingAndTextStyle = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                height: 18px;
                margin-bottom: 4px;
            `,
        },
    }),
};
